<h5 class="card-title">
  <span data-automation="card-title" class="font-regular">{{ label() | translate }}</span>
  <i
    data-automation="card-title-icon"
    class="{{ ZiroIcons.TOOLTIP }} ms-1 card-title__icon"
    [ngbTooltip]="labelTooltip() | translate"
  ></i>
</h5>
